// @flow

import './App.css';

import React, { useEffect, useState, useCallback, useMemo } from 'react'

// import { library } from '@fortawesome/fontawesome-svg-core';
// import { fas } from '@fortawesome/free-solid-svg-icons';

import { styled, useTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
// import MenuIcon from '@mui/icons-material/Menu';
// import AccountCircle from '@mui/icons-material/AccountCircle';
// import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { Menu, MenuItem, ListItemText, ListItemIcon, Switch } from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';
import ViewCompactIcon from '@mui/icons-material/ViewCompact';
// import ViewListIcon from '@mui/icons-material/ViewList';
import Paper from '@mui/material/Paper';
// import DialogActions from '@mui/material/DialogActions';
// import Button from '@mui/material/Button';
import dayjs from 'dayjs';
import ListAltIcon from '@mui/icons-material/ListAlt';
// import Snackbar from '@mui/material/Snackbar';
// import Stack from '@mui/material/Stack';
// import { useDropzone } from 'react-dropzone';
// import { DropzoneDialog } from 'material-ui-dropzone';
import SettingsIcon from '@mui/icons-material/Settings';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import LockIcon from '@mui/icons-material/Lock';
import { useIdleTimer } from 'react-idle-timer';
// import TextField from '@mui/material/TextField';
// import { DndProvider } from 'react-dnd'
// import { HTML5Backend } from 'react-dnd-html5-backend'
// import { pdfjs } from 'pdfjs-dist';
import * as DmsService from './supports/dms-service';
import * as DmsCommon from './supports/dms-common';
import Tooltip from '@mui/material/Tooltip';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';
import CloudOffIcon from '@mui/icons-material/CloudOff';

import { GlobalEvent, GlobalState } from './components/GlobalContext';
import FolderTreeList2 from './components/FolderTreeList2';
import SignInDialog from './components/SignInDialog';
import LogoutDialog from './components/LogoutDialog';
import MaintenanceDialog from './components/MaintenanceDialog';
import ChangePwdDialog from './components/ChangePwdDialog';
import MsgDialog from './components/MsgDialog';
// import MainContentFooter from './components/MainContentFooter';
import UploadFilesDialog from './components/UploadFilesDialog';
import UploadFilesProgress from './components/UploadFilesProgress';
import DocDetailDialog from './components/DocDetailDialog';
import DeptListDialog from './components/DeptListDialog';
import FolderInfoDialog from './components/FolderInfoDialog';
import MainContent from './components/MainContent';
// import IFrameDialog from './components/IFrameDialog';
// import ConfirmDialog from './components/ConfirmDialog';


import ConfirmSendNotificaitonDialog from './components/ConfirmSendNotificaitonDialog'
import SendNotificationForMoveDocDialog from './components/SendNotificationForMoveDocDialog';

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { FileViewerDialog, isOfficeFile, openOfficeFileInNewTab } from './components/FileViewer';

// import Draggable from 'devextreme-react/draggable';
// import 'devextreme/dist/css/dx.light.css';
// import 'devextreme/dist/css/dx.material.blue.light.compact.css';

// import * as markerjs2 from 'markerjs2';

// library.add(fas);

const drawerWidth = 300;


// Setup global context
// const [state, dispatch] = React.useReducer(GlobalReducer, initialState);


function App(props) {

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };



  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);


  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showDeptList, setShowDeptList] = useState(false);
  const [showSearchRst, setShowSearchRst] = useState(false);
  const [errMsg, setErrMsg] = useState("");
  const [selDept, setSelDept] = useState(null);

  const selSysID = (selDept?.DeptCode || "");
  // const selFolderID = useStateful(DmsCommon.VOID_FOLDER_ID)
  const [selFolder, setSelFolder] = useState(null);

  const [folders, setFolders] = useState([]);
  const [searchFolders, setSearchFolders] = useState([]);
  const [folderDocs, setFolderDocs] = useState([]);
  // const [docCount, setDocCount] = useState(0);
  const [searchDocs, setSearchDocs] = useState([]);
  const [docTypes, setDocTypes] = useState([]);
  const [isMonitorOffline, setIsMonitorOffline] = useState(false);

  const selFolderRef = React.useRef(selFolder);
  const isMonitorOfflineRef = React.useRef(isMonitorOffline);
  const foldersRef = React.useRef(folders);
  const searchDocsRef = React.useRef(searchDocs);
  const [isFromExternal, setIsFromExternal] = useState(false);
  const isFromExternalRef = React.useRef(false);

  useEffect(() => {
    selFolderRef.current = selFolder;
  }, [selFolder]);

  useEffect(() => {
    isMonitorOfflineRef.current = isMonitorOffline;
  }, [isMonitorOffline]);

  useEffect(() => {
    foldersRef.current = folders;
  }, [folders]);

  useEffect(() => {
    searchDocsRef.current = searchDocs;
  }, [searchDocs]);

  const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);
  // const [openIFrameDialog, setOpenIFrameDialog] = useState(false);
  const [openImageViewerDialog, setOpenImageViewerDialog] = useState(false);
  // const [fileTitle, setFileTitle] = useState("");
  const [fileSrc, setFileSrc] = useState("");



  const handleCompactModeToggle = () => {
    // console.log("handleCompactModeToggle", gState.useCompactMode);
    const newValue = !gState.useCompactMode;
    localStorage.setItem("useCompactMode", newValue);
    gStateDispatch({ useCompactMode: newValue });

    handleMenuClose();
  };



  // Serach Result Folder
  const SearchResultFolder = {
    id: DmsCommon.SEARCH_FOLDER_ID,
    ParentID: 0,
    FolderName: "Search Result",
    FolderPath: "Search Result",
    Grade: 8,
    LinkedFolderID: 0,
    UnreadCnt: 0,
  }

  // Physical Locations of documents
  const PhyLocFolder = {
    id: DmsCommon.PHY_LOC_FOLDER_ID,
    ParentID: 0,
    FolderName: "文件位置",
    FolderPath: "文件位置",
    Grade: 8,
    LinkedFolderID: 0,
    UnreadCnt: 0,

    IsPhyLocFolder: true,
  }

  const [openSignInDialog, setOpenSignInDialog] = useState(false);

  const handleNormalFuncError = (e, aLabel) => {

    if (e.isInvalidSession === true) {
      doLogout();
      setOpenSignInDialog(true);
    } else {
      let vErrMsg = e?.errMsg || e?.message || 'Unknown Error';

      if (e instanceof DmsService.DmsSvcError) {
        setErrMsg(vErrMsg);
        setShowError(true);

      } else {
        if (aLabel) {
          vErrMsg += ` (${aLabel})`;
          const vDomain = gState?.domain || '';
          const vLoginID = gState?.userID || '';
          DmsService.loggingPromise(vErrMsg, `${vDomain}\\${vLoginID}`, null, gState.sessionID, 1);
        }


        setErrMsg(vErrMsg);
        setShowError(true);

      }
    }


  }



  const doLogout = () => {
    setSelDept(null);

    setSelFolder(null);

    setFolders([]);
    setSearchFolders([]);
    setFolderDocs([]);
    setFolderDocTot(0);

    setShowSearchRst(false);
    // setSearchDocs([]);

    localStorage.removeItem("sessionID");
    localStorage.removeItem("depts");
    localStorage.removeItem("fullName");

    const dispatchValues = {
      lastCheckTime: dayjs().toISOString(),
      sessionID: "",
      fullName: "",
      depts: [],
    }
    gStateDispatch(dispatchValues);

    window.location.href = window.location.href.split("?")[0];

  }

  // console.log("window.location.href.split(?)[0]", window.location.href.split("?")[0]);

  const doSetCurDept = (ACurDept, ASelFolderID) => {

    let isMounted = true;
    // let vDept = gState.depts.find(dept => dept.DeptCode === ADeptCode);
    // console.log("gState", gState);
    if (ACurDept) {
      // DmsService.getAdminFolderByUserPromise(gState.sessionID, ACurDept.DeptCode)
      //   .then(aAdminFolders => {

      //     if (isMounted) {
      //       // console.log("getAdminFolderByUserPromise return", aAdminFolders);
      //       // console.log("vDept", ACurDept);
      //       setAdminFolders(aAdminFolders);

      //       const vShowMaintenance =
      //         ((ACurDept.AdminLevel & DmsCommon.SystemAdminEnum.saSecurity) == DmsCommon.SystemAdminEnum.saSecurity) ||
      //         ((ACurDept.AdminLevel & DmsCommon.SystemAdminEnum.saData) == DmsCommon.SystemAdminEnum.saData) ||
      //         (aAdminFolders.length > 0);
      //       // console.log("vShowMaintenance", vShowMaintenance);
      //       setShowMaintain(vShowMaintenance);

      //     }


      //   })
      //   .catch((e) => {
      //     handleNormalFuncError(e, 'dscd');
      //   })

      // refreshFoldersByDeptCode(ACurDept.DeptCode, ASelFolderID);



      const xFunc = async () => {
        gStateDispatch({ curDeptCode: ACurDept.DeptCode, });
        setSelDept(ACurDept);

        localStorage.curDeptCode = ACurDept.DeptCode;
        localStorage.curDeptName = ACurDept.DeptName;

        try {
          await refreshFoldersByDeptCode(ACurDept.DeptCode, ASelFolderID);
        } catch (e) {
          handleNormalFuncError(e, 'dscd1');
        }


        try {
          const vAdminFolders = await DmsService.getAdminFolderByUserPromise(gState.sessionID, ACurDept.DeptCode);

          if (isMounted) {
            // console.log("getAdminFolderByUserPromise return", aAdminFolders);
            // console.log("vDept", ACurDept);
            setAdminFolders(vAdminFolders);

            const vShowMaintenance =
              ((ACurDept.AdminLevel & DmsCommon.SystemAdminEnum.saSecurity) == DmsCommon.SystemAdminEnum.saSecurity) ||
              ((ACurDept.AdminLevel & DmsCommon.SystemAdminEnum.saData) == DmsCommon.SystemAdminEnum.saData) ||
              (vAdminFolders.length > 0);
            // console.log("vShowMaintenance", vShowMaintenance);
            setShowMaintain(vShowMaintenance);

          }

        } catch (e) {
          handleNormalFuncError(e, 'dscd2');
        }

      }
      xFunc();


    }

    return () => {
      isMounted = false;
    };

  }


  const refreshFoldersByDeptCode = async (ADeptCode, ASelFolderID) => {

    let isMounted = true;

    if (ADeptCode === "") { return }

    if (ASelFolderID === DmsCommon.VOID_FOLDER_ID) { return }

    setShowLoading(true);

    try {
      if (gState.sessionID === "") { throw new Error("Invalid SessionID!") }

      // const p1 = DmsService.logIfLongRunningGetFoldersPromise(gState.sessionID, ADeptCode)
      // const p2 = DmsService.getRFID_ReadersPromise(gState.sessionID, ADeptCode)
      // const [rstFolders, rstReaders] = await Promise.all([p1, p2])

      const rstFolders = await DmsService.logIfLongRunningGetFoldersPromise(gState.sessionID, ADeptCode);
      const rstReaders = await DmsService.getRFID_ReadersPromise(gState.sessionID, ADeptCode);


      setShowLoading(false);


      if (!rstFolders) return;

      if (isFromExternalRef.current && Array.isArray(rstFolders)) {
        const hiddenIDs = new Set();
        rstFolders.forEach(f => {
          if (f.IsMonitorFolder && !f.InternetAccess) {
            hiddenIDs.add(f.id);
            if (f.LinkedFolderID) hiddenIDs.add(f.LinkedFolderID);
          }
        });
        let changed = true;
        while (changed) {
          changed = false;
          rstFolders.forEach(f => {
            if (!hiddenIDs.has(f.id)) {
              if (hiddenIDs.has(f.ParentID) || (f.LinkedFolderID && hiddenIDs.has(f.LinkedFolderID))) {
                hiddenIDs.add(f.id);
                changed = true;
              }
            }
          });
        }
        for (let i = rstFolders.length - 1; i >= 0; i--) {
          if (hiddenIDs.has(rstFolders[i].id)) {
            rstFolders.splice(i, 1);
          }
        }
      }

      if (rstReaders.length > 0) {

        rstFolders.push(PhyLocFolder);

        let i = 0;
        const vReaderFolders = rstReaders.map((item) => {

          i += 1;
          return {
            id: 1000000 + i,
            ParentID: DmsCommon.PHY_LOC_FOLDER_ID,
            FolderName: item.Location,
            FolderPath: item.Location,
            Grade: 8,
            LinkedFolderID: 0,
            UnreadCnt: 0,
            CreatedBy: "",

            IsPhyLocFolder: true,
            // ReaderID: item.ReaderID,
          }
        });

        rstFolders.push(...vReaderFolders);
      }

      if (showSearchRst === true) {
        // Find unreadCnt for Search Folder
        // console.log("searchDocs", searchDocs);
        let vUnreadCnt = 0;
        searchDocs.forEach(item => {
          if (item.HasRead === false) {
            vUnreadCnt++;
          }
        })

        SearchResultFolder.UnreadCnt = vUnreadCnt;
        rstFolders.push(SearchResultFolder);

      }


      const vCheck = checkFolderAndAllParentExists(rstFolders, ASelFolderID);

      const findFolder = rstFolders.find(f => f.id === ASelFolderID);

      if (isMounted) {
        if (vCheck && findFolder) {
          setSelFolder(findFolder);
        } else {
          setSelFolder(null);
        }

        setFolders(rstFolders);

        const vSerachFolder = rstFolders.filter(f => f.id != DmsCommon.SEARCH_FOLDER_ID);
        setSearchFolders(vSerachFolder);
      }


    }
    catch (e) {
      setShowLoading(false);

      setSelFolder(null);
      setFolders([]);
      setSearchFolders([]);
      setFolderDocs([]);
      setFolderDocTot(0);

      // Intented to not showing error here
      handleNormalFuncError(e, 'rfbd');

      console.log('Fail: ', e);
    };

    return () => {
      isMounted = false;
    };

  }



  const [folderDocTot, setFolderDocTot] = useState(0);

  const onFetchedDoc = (aData, aRecordCnt) => {
    // console.log(' onFetchedDoc:', aData, aRecordCnt);

    setFolderDocs(aData);
    setFolderDocTot(aRecordCnt);

  }






  const checkFolderAndAllParentExists = (aFolderList, aFolderID) => {

    if ([DmsCommon.ALL_FOLDER_ID, DmsCommon.PERSONAL_FOLDER_ID].includes(aFolderID)) {
      return true;
    }

    const vFolder = aFolderList.find(f => f.id === aFolderID);
    if (vFolder) {
      return checkFolderAndAllParentExists(aFolderList, vFolder.ParentID);
    } else {
      return false;
    }
  }

  // const [shareSessionID, setShareSessionID] = useState("");
  // const [passInFolderID, setPassInFolderID] = useState(DmsCommon.VOID_FOLDER_ID);
  const [passInDone, setPassInDone] = useState(false);
  const [passInDocID, setPassInDocID] = useState(0);

  const onAfterAuth = async (ADeptCode, ADeptList) => {
    // console.log("call onAfterAuth", ADeptCode, ADeptList);

    // Reset idle timer
    // console.log('Reset idle timer');
    reset();

    const vPassInSSID = DmsCommon.getUrlParam('s') || '';

    const vPassInEncodedDocID = DmsCommon.getUrlParam('d') || '';
    const vDecoded = Buffer(decodeURIComponent(vPassInEncodedDocID), 'base64').toString('ascii');
    // console.log('onAfterAuth ~ vDecoded:', vDecoded);
    const vPassInDocSysID = DmsCommon.getUrlParam2(vDecoded, "sysID");
    const vPassInDocID = parseInt(DmsCommon.getUrlParam2(vDecoded, "docID"));

    const vPassInEncodedFolderID = DmsCommon.getUrlParam('f') || '';
    const vDecoded2 = Buffer(decodeURIComponent(vPassInEncodedFolderID), 'base64').toString('ascii');
    const vPassInFolderSysID = DmsCommon.getUrlParam2(vDecoded2, "sysID");
    const vPassInFolderID = parseInt(DmsCommon.getUrlParam2(vDecoded2, "folderID"));

    const xNormalRoute = () => {

      if (ADeptList.length === 0) {
        // setErrMsg("No department is found");
        // setShowError(true);
      } else if (ADeptList.length == 1) {
        doSetCurDept(ADeptList[0])
      } else {
        const vDept = ADeptList.find(dept => dept.DeptCode === ADeptCode);
        if (vDept) {
          doSetCurDept(vDept);
        } else
          setShowDeptList(true);
      }

    }


    if (vPassInSSID != "" && !passInDone) {
      // console.log("xNormalRoute", 1);
      try {
        const { docs: aResult } = await DmsService.getDocsPromise2(gState.sessionID, '', 0, 0,
          '', 0, vPassInSSID);

        // console.log("aResult", aResult);

        setPassInDone(true);

        const vSysID = aResult[0]?.SysID || "";
        const vPassInFolderID = (aResult[0]?.FolderID == undefined ? DmsCommon.VOID_FOLDER_ID : aResult[0]?.FolderID);
        const vPassInDocID = aResult[0]?.DocID || 0;
        // console.log("go", vSysID, vFolderID, vDocID);
        // const vFolder = folders.find(f => f.id === vFolderID);
        // console.log('onAfterAuth ~ folders:', folders);
        // console.log('onAfterAuth ~ vFolder:', vFolder);


        const vDept = ADeptList.find(dept => dept.DeptCode === vSysID);
        if (vDept) {
          try {
            const aCheckFolders = await DmsService.logIfLongRunningGetFoldersPromise(gState.sessionID, vSysID);

            const vHasFolderPermission = aCheckFolders.find(f => f.id === vPassInFolderID);

            const vHasFolderAndPathPermission = checkFolderAndAllParentExists(aCheckFolders, vPassInFolderID);
            // console.log('onAfterAuth ~ vCheck:', vCheck);

            if (vHasFolderAndPathPermission) {
              setPassInDocID(vPassInDocID);
              doSetCurDept(vDept, vPassInFolderID);
            } else if (vHasFolderPermission) {
              setPassInDocID(vPassInDocID);
              doSetCurDept(vDept);
            } else {
              xNormalRoute();
            }
          } catch (e) {
            throw e
          }


        } else {
          xNormalRoute();
        }
      } catch (e) {
        xNormalRoute();
      }


    } else if (vPassInDocSysID != "" && vPassInDocID > 0 && !passInDone) {
      // console.log("xNormalRoute", 2);

      try {
        setPassInDone(true);

        // Try to get FolderID of PassInDocID
        const vDocData = await DmsService.getDocDetailPromise(gState.sessionID, vPassInDocSysID, vPassInDocID);
        // console.log("vDocData", vDocData);
        const vFolderID = (vDocData?.FolderID == undefined ? DmsCommon.VOID_FOLDER_ID : vDocData?.FolderID);


        const vDept = ADeptList.find(dept => dept.DeptCode === vPassInDocSysID);
        if (vDept) {
          try {
            const aCheckFolders = await DmsService.logIfLongRunningGetFoldersPromise(gState.sessionID, vPassInDocSysID);
            // console.log('onAfterAuth ~ aCheckFolders:', aCheckFolders);

            const vHasFolderPermission = aCheckFolders.find(f => f.id === vFolderID);

            const vHasFolderAndPathPermission = checkFolderAndAllParentExists(aCheckFolders, vFolderID);

            if (vHasFolderAndPathPermission) {
              setPassInDocID(vPassInDocID);
              doSetCurDept(vDept, vFolderID);
            } else if (vHasFolderPermission) {
              setPassInDocID(vPassInDocID);
              doSetCurDept(vDept);
            } else {
              xNormalRoute();
            }
          } catch (e) {
            throw e
          }

          // setPassInDocID(vPassInDocID);
          // doSetCurDept(vDept, vFolderID);
        } else {
          throw new Error(`Fail to access the department!`)
        }


      }
      catch (e) {
        handleNormalFuncError(e, 'affu');
        xNormalRoute();
      };
    } else if (vPassInFolderSysID != "" && vPassInFolderID > 0 && !passInDone) {
      // console.log("xNormalRoute", 3);

      try {
        setPassInDone(true);

        const vDept = ADeptList.find(dept => dept.DeptCode === vPassInFolderSysID);
        if (vDept) {
          doSetCurDept(vDept, vPassInFolderID);
        } else {
          throw new Error(`Fail to access the department!`)
        }


      }
      catch (e) {
        handleNormalFuncError(e, 'oaa');
        xNormalRoute();
      };

    } else {
      // console.log("xNormalRoute", 4);
      xNormalRoute();
    }


  }



  const handleIdle = () => {
    console.log('handleIdle');
    if (gState.sessionID && gState.sessionID.length > 0) {
      // console.log('do logout since idle');

      const ex = new Error();
      ex.isInvalidSession = true;
      ex.errMsg = 'Session timeout!';
      //   dispatch(showAppErr(ex));
      handleNormalFuncError(ex);
    };
  }

  const timeout = 1000 * 3600 * 2;
  // const timeout = 1000 * 3;
  const { reset } = useIdleTimer({
    timeout,
    onIdle: handleIdle,
  });

  // Use once when mounted
  useEffect(() => {
    console.log("useEffect App(did mounted)");

    DmsService.isExternalPromise().then(res => {
      setIsFromExternal(res);
      isFromExternalRef.current = res;
    }).catch(() => { });

    const xFunc = async () => {
      let vPassInJwtAppID = DmsCommon.getUrlParam('appid') || '';
      let vPassInJwt = DmsCommon.getUrlParam('token') || '';
      // let vPassInAppVer = DmsCommon.getUrlParam('appVer') || '';
      // let vPassInDevice = DmsCommon.getUrlParam('device') || '';
      // let vPassInDeviceVer = DmsCommon.getUrlParam('deviceVer') || '';

      // Try get the appID and token from cookies
      if (vPassInJwtAppID == "" && vPassInJwt == "") {
        vPassInJwtAppID = DmsCommon.getCookie('appid') || '';
        vPassInJwt = DmsCommon.getCookie('token') || '';
        // vPassInAppVer = DmsCommon.getCookie('appVer') || '';
        // vPassInDevice = DmsCommon.getCookie('device') || '';
        // vPassInDeviceVer = DmsCommon.getCookie('deviceVer') || '';

        DmsCommon.deleteCookie('appid');
        DmsCommon.deleteCookie('token');
        // DmsCommon.deleteCookie('appVer');
        // DmsCommon.deleteCookie('device');
        // DmsCommon.deleteCookie('deviceVer');
      }

      // console.log('vPassInJwtAppID:', vPassInJwtAppID);
      // console.log('vPassInJwt:', vPassInJwt);


      if (vPassInJwtAppID != "" && vPassInJwt != "") {
        setShowLoading(true)

        try {
          let vJwtResult = await DmsService.logonByJwtPromise(vPassInJwtAppID, vPassInJwt);
          // console.log('logonByJwtPromise return', vJwtResult);

          if (vJwtResult.success != true) {
            throw new Error(vJwtResult.errMsg || 'Fail to logon by JWT!');
          }

          setShowLoading(false);

          const vDispatchValues = DmsService.digestDataAfterAuth(
            vJwtResult.loginID, vJwtResult.domain, null, vJwtResult);
          // console.log("vDispatchValues", vDispatchValues);

          localStorage.jwtPassFlag = '1';

          gStateDispatch(vDispatchValues);



        } catch (e) {
          // console.log('checkSessionPromise fail', e);
          setShowLoading(false);
          setOpenSignInDialog(true);
        }

      } else if (gState.sessionID && gState.sessionID.length > 0) {

        setShowLoading(true)

        try {
          let AResultData = await DmsService.checkSessionPromise(gState.sessionID);
          // console.log('checkSessionPromise return', AResultData);

          setShowLoading(false);

          const vDispatchValues = DmsService.digestDataAfterAuth(null, null, gState.sessionID, AResultData)
          // console.log("vDispatchValues", vDispatchValues);
          const vCurDeptCode = gState.curDeptCode;

          gStateDispatch(vDispatchValues);


          onAfterAuth(vCurDeptCode, vDispatchValues.depts);

        } catch (e) {
          // console.log('checkSessionPromise fail', e);
          setShowLoading(false);
          setOpenSignInDialog(true);
        }



      } else {
        setOpenSignInDialog(true);
      }
    }
    xFunc();




  }, [])

  useEffect(() => {

    if (localStorage.jwtPassFlag === '1') {
      localStorage.jwtPassFlag = '';


      // Remove JWT parameters from URL
      const url = new URL(window.location.href);
      const params = ['appid', 'token'];

      params.forEach(name => {
        url.searchParams.delete(name);
      });

      // 🔄 Update the browser URL without reloading
      window.history.replaceState({}, '', url.toString());

      onAfterAuth(gState.curDeptCode, gState.depts);
    }

  }, [gState])


  useEffect(() => {
    // console.log("useEffect App")
    // console.log('App.gState: ', gState)

    if (localStorage.signInPassFlag == '1') {
      // console.log("App.signInPassFlag routine")

      localStorage.signInPassFlag = '';

      onAfterAuth("", gState.depts);

    }

  })

  useEffect(() => {
    // console.log("useEffect App[gEvent.showErr]", gEvent);

    if (gEvent.showErr === true) {
      if (gEvent.err) {
        handleNormalFuncError(gEvent.err);
      }

      gEventDispatch({
        showErr: false,
      });
    }

  }, [gEvent.showErr])

  useEffect(() => {
    let timerId = null;

    const checkStatus = async () => {
      if (gState.sessionID && selFolder && selFolder.IsMonitorFolder) {
        try {
          const res = await DmsService.getMonitorFolderStatusPromise(
            gState.sessionID,
            selSysID,
            selFolder.id
          );
          setIsMonitorOffline(res.isOffline);
        } catch (error) {
          console.error("Failed to check monitor folder status:", error);
        }
      }
    };

    if (selFolder?.IsMonitorFolder) {
      checkStatus();
      timerId = setInterval(checkStatus, 5000);
    } else {
      setIsMonitorOffline(false);
    }

    return () => {
      if (timerId) {
        clearInterval(timerId);
      }
    };
  }, [gState.sessionID, selFolder, selSysID]);

  const isFolderNormal = (aFolder) => {
    const vIsNormalFolder = aFolder && ![
      DmsCommon.ALL_FOLDER_ID,
      DmsCommon.PERSONAL_FOLDER_ID,
      DmsCommon.SEARCH_FOLDER_ID,
    ].includes(aFolder.id);

    const vIsPhyLocFolder = aFolder?.IsPhyLocFolder;

    return (vIsNormalFolder && !vIsPhyLocFolder);
  }

  // When selFolder changed
  useEffect(async () => {
    // console.log("useEffect App[selFolder]", selFolder);

    const vIsNormalFolder = isFolderNormal(selFolder);

    // Disable upload for DMS_PL
    const vIsDMS_PL = (selDept?.DeptCode === 'DMS_PL');

    if (vIsDMS_PL) {
      setDisabledUpload(true)
    } else {
      if (selFolder?.IsMonitorFolder) {
        if (selFolder?.Grade >= DmsCommon.AccessRightEnum.arModify) {
          setDisabledUpload((vIsNormalFolder && selDept) ? false : true);
        } else {
          setDisabledUpload(true);
        }
      } else {
        setDisabledUpload((vIsNormalFolder && selDept) ? false : true);

      }
    }


    // await refreshDocs();


  }, [selFolder])



  // When selFolder changed
  useEffect(() => {
    // console.log("useEffect App[searchDocs]", searchDocs);

    refreshFolders();


  }, [searchDocs])

  const handleConfirmLogout = () => {
    setOpenLogoutDialog(false);
    doLogout();
    setOpenSignInDialog(true);
  }

  const handleViewDoc = (ADocID) => {

    const aFunc = async () => {

      // console.log(`handleViewDoc (${ADocID})`)
      if (selFolder?.IsMonitorFolder && isMonitorOffline) {
        const e = new Error("The path is offline");
        handleNormalFuncError(e, 'hvd1');
        return;
      }

      if (isFromExternalRef.current && selFolder?.IsMonitorFolder && !selFolder?.InternetAccess) {
        const e = new Error("Access denied: Internet access is not enabled for this folder!");
        handleNormalFuncError(e, 'hvd_ext1');
        return;
      }

      const { docs: vRst } = await DmsService.getDocsPromise2(gState.sessionID, selSysID, 0, '', '', ADocID, '');
      const findDoc = (vRst.length > 0) ? vRst[0] : null;

      if (findDoc) {
        const findFolder = folders.find(f => f.id === findDoc.FolderID) || selFolder;
        if (isFromExternalRef.current && findFolder?.IsMonitorFolder && !findFolder?.InternetAccess) {
          const e = new Error("Access denied: Internet access is not enabled for this folder!");
          handleNormalFuncError(e, 'hvd_ext2');
          return;
        }

        if (findFolder?.IsMonitorFolder && findFolder.id !== selFolder?.id) {
          try {
            const res = await DmsService.getMonitorFolderStatusPromise(gState.sessionID, selSysID, findFolder.id);
            if (res.isOffline) {
              const e = new Error("The path is offline");
              handleNormalFuncError(e, 'hvd2');
              return;
            }
          } catch (err) {
            console.error("Failed to check monitor folder status:", err);
          }
        }
        // console.log('aFunc ~ findFolder:', findFolder);
        const canView = findFolder && (findFolder.Grade >= DmsCommon.AccessRightEnum.arReadDoc);
        const canDownload = findFolder && (findFolder.Grade >= DmsCommon.AccessRightEnum.arReadDn);
        // console.log('aFunc ~ canView:', canView);
        if (!canView) {
          const e = new Error(`Can't open document '${findDoc.Subject}'. Access denied!`)

          handleNormalFuncError(e, 'hvd3');
          return
        }

        if (findDoc.FileName === "") {
          const e = new Error(`Blank File can't be viewed or downloaded!`)

          handleNormalFuncError(e);
          return
        }

        // selDocID.setValue(ADocID);

        // console.log('findDoc', findDoc);

        const DOWNLOAD_EXT_LIST = ['.pdf', '.jpeg', '.jpg', '.gif', '.png', '.bmp', '.mp4', '.m4v', '.mov', '.docx', '.xlsx', '.xls', '.csv', '.txt'];
        const IMG_EXT_LIST = ['.jpeg', '.jpg', '.gif', '.png', '.bmp'];

        const vOpenAsDownload = (DOWNLOAD_EXT_LIST.includes(findDoc.FileExt.toLowerCase())) ? 0 : 1;
        const vIsImg = (IMG_EXT_LIST.includes(findDoc.FileExt.toLowerCase()));

        const vIsPdf = (findDoc.FileExt === '.pdf');
        const vIsOffice = isOfficeFile(findDoc.FileName || findDoc.FileExt);

        if (vIsOffice) {
          const vDownloadUrlWithFilename = DmsService.getDownloadUrlWithFilename(gState.sessionID,
            findDoc.SysID, findDoc.DocID, findDoc.RevNo, null, null, null, 0,
            findDoc.FileName);

          openOfficeFileInNewTab({
            url: vDownloadUrlWithFilename,
            filename: findDoc.FileName,
            title: findDoc.Subject || findDoc.FileName,
            canDownload: canDownload,
          });
        } else if (vIsPdf) {


          if (isMobileDevice) {
            // setFileTitle(findDoc.Subject)
            // setFileSrc(vPdfViewerLink);
            // setOpenIFrameDialog(true);

            const vDownloadUrl = DmsService.getDownloadUrl(gState.sessionID,
              findDoc.SysID, findDoc.DocID, findDoc.RevNo, null, null, null, vOpenAsDownload);

            window.open(vDownloadUrl, '_blank');
          } else {
            const vDownloadUrlWithFilename = DmsService.getDownloadUrlWithFilename(gState.sessionID,
              findDoc.SysID, findDoc.DocID, findDoc.RevNo, null, null, null, vOpenAsDownload,
              findDoc.FileName);
            // console.log('aFunc ~ vDownloadUrlWithFilename:', vDownloadUrlWithFilename);
            // console.log('aFunc ~ encodeURIComponent(vDownloadUrlWithFilename):', encodeURIComponent(vDownloadUrlWithFilename));


            const vEncodedUrl = DmsCommon.encodeStrForPassing(vDownloadUrlWithFilename);
            // console.log('aFunc ~ vEncodedUrl:', vEncodedUrl);

            const vPdfViewerLink = `/pdfviewer/web/viewer.html?file=${vEncodedUrl}&disableDownload=${canDownload ? 'false' : 'true'}`;

            window.open(vPdfViewerLink, '_blank');
            // setShowPdfViewer(true);
          }


        } else {
          const vIsVideo = ['.mp4', '.m4v', '.mov'].includes(findDoc.FileExt);

          let vDownloadURL
          if (vIsVideo) {
            if (isMobileDevice) {
              vDownloadURL = DmsService.getDownloadUrl(gState.sessionID, findDoc.SysID, findDoc.DocID, findDoc.RevNo, null, null, null, vOpenAsDownload);
            } else {
              vDownloadURL = DmsService.getVideoUrl(gState.sessionID, findDoc.SysID, findDoc.DocID, findDoc.RevNo, null, null, null, vOpenAsDownload);
              // setFileTitle(findDoc.Subject)
              // setFileSrc(vDownloadURL);
              // setOpenIFrameDialog(true);
            }
            window.open(vDownloadURL, '_blank');

          } else {
            vDownloadURL = DmsService.getDownloadUrl(gState.sessionID, findDoc.SysID, findDoc.DocID, findDoc.RevNo, null, null, null, vOpenAsDownload);
            if (vIsImg) {
              if (isMobileDevice) {
                window.open(vDownloadURL, '_blank');
              } else {
                // setFileTitle(findDoc.Subject)
                setFileSrc(vDownloadURL);
                setOpenImageViewerDialog(true);

              }

            } else {
              window.open(vDownloadURL, '_blank');
            }

          }
          // window.open(vDownloadURL, '_blank');



        }

        DmsService.updateDocDListLogPromise(gState.sessionID, findDoc.SysID, findDoc.DocID, findDoc.RevNo);

        if (!findDoc.HasRead) {
          DmsService.markDocAsReadPromise(gState.sessionID, findDoc.SysID, findDoc.DocID);
        }

      }

    }
    aFunc();



  }

  const handleDownloadDoc = (aDocList) => {

    const aFunc = async () => {
      // const docList = folderDocs.filter(docItem => ADocIDList.some(docID => docID === docItem.DocID));

      // console.log(`docList`, docList);
      if (selFolder?.IsMonitorFolder && isMonitorOffline) {
        const e = new Error("The path is offline");
        handleNormalFuncError(e, 'hdld1');
        return;
      }

      if (aDocList.length == 1) {
        const vDoc = aDocList[0];

        setShowLoading(true);

        try {
          // Get DocDetail first to check folder status if it's not the selected folder
          const p2Rst = await DmsService.getDocsPromise2(gState.sessionID, selSysID, 0, '', '',
            vDoc.DocID, '');
          const findDoc = (p2Rst.docs.length > 0) ? p2Rst.docs[0] : null;

          if (findDoc) {
            const findFolder = folders.find(f => f.id === findDoc.FolderID);
            if (findFolder?.IsMonitorFolder && findFolder.id !== selFolder?.id) {
              const res = await DmsService.getMonitorFolderStatusPromise(gState.sessionID, selSysID, findFolder.id);
              if (res.isOffline) {
                throw new Error("The path is offline");
              }
            }
          }

          // Stream file download directly to disk
          DmsService.downloadFileStream(
            gState.sessionID,
            selDept.DeptCode,
            vDoc.DocID,
            vDoc.RevNo,
            null,
            null,
            null,
            findDoc ? findDoc.FileName : "",
            () => setShowLoading(true),
            () => setShowLoading(false),
            (err) => {
              handleNormalFuncError(err, 'hdld2');
            }
          );

          if (findDoc) {
            DmsService.updateDocDListLogPromise(gState.sessionID, selDept.DeptCode, vDoc.DocID, vDoc.RevNo);
          }

        } catch (e) {
          setShowLoading(false);

          handleNormalFuncError(e, 'hdld2');
        }


        if (!vDoc.HasRead) {
          DmsService.markDocAsReadPromise(gState.sessionID, selDept.DeptCode, vDoc.DocID);
        }

      } else if (aDocList.length > 1) {
        const vBatchDocList = aDocList.map(item => { return { "docID": item.DocID, "revNo": item.RevNo } });
        // console.log("vBatchDocList", vBatchDocList);

        setShowLoading(true);

        try {
          // Check if any of the batch documents belong to an offline monitor folder
          for (const item of aDocList) {
            const p2Rst = await DmsService.getDocsPromise2(gState.sessionID, selSysID, 0, '', '', item.DocID, '');
            const findDoc = (p2Rst.docs.length > 0) ? p2Rst.docs[0] : null;
            if (findDoc) {
              const findFolder = folders.find(f => f.id === findDoc.FolderID);
              if (findFolder?.IsMonitorFolder && findFolder.id !== selFolder?.id) {
                const res = await DmsService.getMonitorFolderStatusPromise(gState.sessionID, selSysID, findFolder.id);
                if (res.isOffline) {
                  throw new Error("The path is offline");
                }
              }
            }
          }

          const data2 = await DmsService.downloadBatchPromise(gState.sessionID, selDept.DeptCode, vBatchDocList);

          setShowLoading(false);

          const blob = new Blob([data2]);
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = `dms-download-${dayjs().toISOString().replaceAll("-", "").replaceAll(":", "").replaceAll(".", "")}.zip`;
          a.click();

          aDocList.forEach(item => {
            DmsService.updateDocDListLogPromise(gState.sessionID, selDept.DeptCode, item.DocID, item.RevNo);
          })

        } catch (e) {
          setShowLoading(false);

          handleNormalFuncError(e, 'hdld3');
        }


      }
    }
    aFunc();


  }

  const handlePrintIndex = (APrintFolderID, APrintDocIDs, AIncludeSubFolder,
    AIncludeRight, AIncludeComment, AExportExcel) => {
    // console.log(`handlePrintIndex`, APrintDocIDs);
    // console.log(`APrintFolderID`, APrintFolderID);


    if (AExportExcel == true) {
      setShowLoading(true);
      DmsService.downloadPrintIndexExcelPromise(gState.sessionID, selDept.DeptCode,
        APrintFolderID, APrintDocIDs, AIncludeSubFolder, AIncludeRight, AIncludeComment)
        .then(data => {
          setShowLoading(false);

          const blob = new Blob([data]);
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = `dms-docIndex-${dayjs().toISOString().replaceAll("-", "").replaceAll(":", "").replaceAll(".", "")}.xlsx`;
          a.click();

        })
        .catch(e => {
          setShowLoading(false);

          handleNormalFuncError(e, 'hpi');
        })

    } else {

      const windowName = 'w_' + Date.now() + Math.floor(Math.random() * 100000).toString();
      const f = document.createElement("form");
      f.method = "POST";
      f.action = process.env.REACT_APP_DMS_SERVICE_URL + "printDocIdx";
      f.target = windowName;

      const addParam = (aForm, aName, aVal) => {
        const vInput = document.createElement("input");
        vInput.type = "text";
        vInput.name = aName;
        vInput.value = aVal;
        aForm.appendChild(vInput);
      }

      addParam(f, "sysID", selDept.DeptCode);
      addParam(f, "sessionID", gState.sessionID);
      addParam(f, "folderID", APrintFolderID);
      addParam(f, "docIDs", APrintDocIDs.join());
      addParam(f, "includeSubFolder", AIncludeSubFolder ? 1 : 0);
      addParam(f, "includeRight", AIncludeRight ? 1 : 0);
      addParam(f, "includeComment", AIncludeComment ? 1 : 0);
      addParam(f, "exportExcel", 0);
      const dt = new Date();
      const offset = dt.getTimezoneOffset() * 60 * 1000;
      const localTime = new Date(dt.getTime() - offset);
      const dtISO = localTime.toISOString().replace("Z", ""); // remove timezone info
      addParam(f, "printDT", dtISO);

      document.body.appendChild(f);

      const w = window.open('', windowName);

      if (w) {
        f.submit();
      } else {
        alert('You must allow popups.');
      }

      document.body.removeChild(f);

    }

  }

  const handleSearchDoc = (aSearchFolderID, aSearchStr, aUserElastic,
    aDocDateFrom, aDocDateTo, aAdvSearchCriteria) => {
    // console.log("handleSearchDoc", aSearchStr);
    // if (aSearchStr.trim() === "" && aDocDateFrom === "" && aDocDateTo === "") {
    //   setShowSearchRst(false);
    //   setSearchDocs([]);

    // } else {
    setShowLoading(true);
    DmsService.docSearchPromise(gState.sessionID, selDept.DeptCode, aSearchFolderID,
      aSearchStr, aUserElastic, aDocDateFrom, aDocDateTo, aAdvSearchCriteria)
      .then((aDocs) => {

        setShowLoading(false);

        setShowSearchRst(true);
        setSelFolder(SearchResultFolder);
        setSearchDocs(aDocs);

        // handleRefreshFolderClick();
      })
      .catch(e => {
        setShowLoading(false);

        handleNormalFuncError(e, 'hsd');
      })
    // }
  }




  const handleDeleteDoc = async (ADocIDList) => {
    // console.log(`handleDeleteDoc`, ADocIDList);

    if (selFolder?.IsMonitorFolder && isMonitorOffline) {
      const e = new Error("The path is offline");
      handleNormalFuncError(e, 'hdd1');
      return false;
    }

    setShowLoading(true);
    try {
      for (const docID of ADocIDList) {
        const { docs: vRst } = await DmsService.getDocsPromise2(gState.sessionID, selSysID, 0, '', '', docID, '');
        const findDoc = (vRst.length > 0) ? vRst[0] : null;
        if (findDoc) {
          const findFolder = folders.find(f => f.id === findDoc.FolderID);
          if (findFolder?.IsMonitorFolder && findFolder.id !== selFolder?.id) {
            const res = await DmsService.getMonitorFolderStatusPromise(gState.sessionID, selSysID, findFolder.id);
            if (res.isOffline) {
              throw new Error("The path is offline");
            }
          }
        }
      }

      await DmsService.delDocsPromise(gState.sessionID, selDept.DeptCode, ADocIDList);

      setFolderDocs(prev => prev.filter(d => !ADocIDList.includes(d.DocID)));
      setFolderDocTot(prev => Math.max(0, prev - ADocIDList.length));
      setSearchDocs(prev => prev.filter(d => !ADocIDList.includes(d.DocID)));

      return true;
    } catch (e) {
      handleNormalFuncError(e, 'hdd2');
      return false;
    } finally {
      setShowLoading(false);
    }
  };


  const handleChangeFolderID = (AFolderID) => {
    // console.log("handleChangeFolderID", AFolderID);
    // console.log("handleChangeFolderID folders", folders);
    const findFolder = folders.find(f => f.id === AFolderID);
    // console.log("handleChangeFolderID findFolder", findFolder);

    setSelFolder(findFolder);
  }


  const [moveDocIDs, setMoveDocIDs] = useState([]);
  const [moveTargetFolderID, setMoveTargetFolderID] = useState(0);
  const moveDocs = async (aDList) => {

    try {
      setShowLoading(true);
      try {
        await DmsService.docParentUpdatePromise(
          gState.sessionID, gState.curDeptCode, moveDocIDs, moveTargetFolderID, aDList);
      } finally {
        setShowLoading(false);
      }

      refreshFolders();

      // Instead of refreshing the data in searching result, update
      // the folderID in the searched documents
      if (selFolder.id === DmsCommon.SEARCH_FOLDER_ID) {
        // console.log("moveDocs moveDocIDs", moveDocIDs);
        // console.log("moveDocs moveTargetFolderID", moveTargetFolderID);
        // console.log("moveDocs searchDocs", searchDocs);

        const vNewSearchDocs = searchDocs.map(vDoc => {
          if (moveDocIDs.includes(vDoc.DocID)) {
            return {
              ...vDoc,
              "FolderID": moveTargetFolderID,
            }
          } else {
            return vDoc
          }
        })

        // console.log("moveDocs vNewSearchDocs", vNewSearchDocs);
        setSearchDocs(vNewSearchDocs);
      }
    }
    catch (e) {
      handleNormalFuncError(e, 'md');
    };
  }


  const [openMoveDocDialog, setOpenMoveDocDialog] = useState(false);
  const [openSendNotificationMoveDocDialog, setOpenSendNotificationMoveDocDialog] = useState(false);



  const [folderTreeItemsRef, setFolderTreeItemsRef] = useState(null)
  const [docGridRef, setDocGridRef] = useState(null)
  const [infiniteDocGridRef, setInfiniteDocGridRef] = useState(null)


  const [dropZoneList, setDropZoneList] = useState([])


  const setupFolderItemDropZone = () => {
    // console.log('setupFolderItemDropZone ~ folderTreeItemsRef', folderTreeItemsRef);
    // console.log('setupFolderItemDropZone ~ docGridRef', docGridRef);

    if (folderTreeItemsRef && docGridRef && infiniteDocGridRef) {

      dropZoneList.forEach((zone) => {
        docGridRef.api.removeRowDropZone(zone);
        infiniteDocGridRef.api.removeRowDropZone(zone);
      })
      // console.log('dropZoneList', dropZoneList);


      const newDropZoneList = []
      folderTreeItemsRef.forEach((folderItemRef, idx) => {
        const el = folderItemRef.el;
        if (!el) { return }

        const vTargetFolderID = folderItemRef.folderID;
        const vTargetFolder = folders.find(f => f.id === vTargetFolderID);
        const vIsTargetFolderNormal = isFolderNormal(vTargetFolder);
        // console.log('folderTreeItemsRef.forEach ~ vTargetFolder', vTargetFolder);



        // const vIsSourceFolderNormal = isFolderNormal(selFolder);

        // if (!vIsSourceFolderNormal || !vIsTargetFolderNormal) { return }

        if (!vIsTargetFolderNormal) { return }

        if (vTargetFolderID === selFolder?.id) { return }


        const dropZone = {
          getContainer: () => el,
          onDragEnter: () => {
            el.style.color = 'red';
          },
          onDragLeave: () => {
            el.style.color = '';
          },
          onDragStop: async (params) => {
            console.log('onDragStop ~ params', params);
            // console.log('targetFolderID', vTargetFolderID)

            el.style.color = '';
            // const vSourceDocID = params.node.data.DocID;
            const vSourceDocIDs = params.nodes?.map(n => n.data.DocID) || [];
            // console.log('folderTreeItemsRef.forEach ~ vSourceDocIDs', vSourceDocIDs);


            if (vSourceDocIDs.length <= 0) { return }

            const currentSelFolder = selFolderRef.current;
            const currentIsMonitorOffline = isMonitorOfflineRef.current;
            const currentFolders = foldersRef.current;
            const currentSearchDocs = searchDocsRef.current;

            if (currentSelFolder?.IsMonitorFolder && currentIsMonitorOffline) {
              setErrMsg("The path is offline");
              setShowError(true);
              return;
            }

            if (currentSelFolder?.id === DmsCommon.SEARCH_FOLDER_ID) {
              for (const vSrcDocID of vSourceDocIDs) {
                const vSourceDoc = currentSearchDocs.find(d => d.DocID === vSrcDocID);
                const vSourceFolder = currentFolders.find(f => f.id === vSourceDoc?.FolderID);
                if (vSourceFolder?.IsMonitorFolder) {
                  try {
                    const res = await DmsService.getMonitorFolderStatusPromise(gState.sessionID, selSysID, vSourceFolder.id);
                    if (res.isOffline) {
                      setErrMsg("The path is offline");
                      setShowError(true);
                      return;
                    }
                  } catch (err) {
                    console.error(err);
                  }
                }
              }
            }

            if (vTargetFolder?.IsMonitorFolder) {
              try {
                const res = await DmsService.getMonitorFolderStatusPromise(gState.sessionID, selSysID, vTargetFolder.id);
                if (res.isOffline) {
                  setErrMsg("The path is offline");
                  setShowError(true);
                  return;
                }
              } catch (err) {
                console.error(err);
              }
            }

            if (vTargetFolder.Grade < DmsCommon.AccessRightEnum.arModify) {
              setErrMsg(`Can't move document(s). Destination folder (${vTargetFolder.FolderName}) is read-only!`);
              setShowError(true);
              return
            }

            // Checking permission of folder in source document
            if (currentSelFolder.id === DmsCommon.SEARCH_FOLDER_ID) {
              // console.log("SearchFolder vSourceDocIDs", vSourceDocIDs);
              console.log("SearchFolder searchDocs", currentSearchDocs);

              const vReadOnlyFolderDocs = []
              vSourceDocIDs.forEach(vSrcDocID => {
                const vSourceDoc = currentSearchDocs.find(d => d.DocID === vSrcDocID);
                const vSourceFolder = currentFolders.find(f => f.id === vSourceDoc?.FolderID);

                if (vSourceFolder) {
                  if (vSourceFolder.Grade < DmsCommon.AccessRightEnum.arModify) {
                    vReadOnlyFolderDocs.push({
                      "FolderName": vSourceFolder.FolderName,
                      "Subject": vSourceDoc.Subject,
                    })
                  }
                }
              });

              if (vReadOnlyFolderDocs.length > 0) {
                // console.log("vReadOnlyFolderDocs", vReadOnlyFolderDocs);

                setErrMsg(<>
                  {`Can't move document(s). The following source folder(s) are read-only`}:
                  <ul>
                    {vReadOnlyFolderDocs.map((d, index) => (
                      <li key={index}>Folder: {d.FolderName} (Document: {d.Subject})</li>
                    ))}
                  </ul>
                </>);
                setShowError(true);
                return
              }

            } else {
              const vIsSourceFolderNormal = isFolderNormal(currentSelFolder);

              if (!vIsSourceFolderNormal) { return }

              if (currentSelFolder.Grade < DmsCommon.AccessRightEnum.arModify) {
                setErrMsg(`Can't move document(s). Source folder (${currentSelFolder.FolderName}) is read-only!`);
                setShowError(true);
                return
              }

            }


            setMoveDocIDs(vSourceDocIDs);
            setMoveTargetFolderID(vTargetFolderID);
            setOpenMoveDocDialog(true);

          }
        };

        newDropZoneList.push(dropZone)
        docGridRef.api.addRowDropZone(dropZone);
        infiniteDocGridRef.api.addRowDropZone(dropZone);
        // console.log('docGridRef.api.addRowDropZone:', dropZone);
      })

      setDropZoneList(newDropZoneList);

    }

  }



  const handleFolderListChanged = (aItemListRef) => {
    // console.log('handleItemListChanged ~ aItemListRef', aItemListRef);
    setFolderTreeItemsRef(aItemListRef);

    setupFolderItemDropZone();
  }

  const [openFolderInfoDialog, setOpenFolderInfoDialog] = useState(false);

  const handleFolderInfoClick = () => {
    // console.log('handleFolderInfoClick');
    if (selFolder) {
      setOpenFolderInfoDialog(true);
    }
  }

  const handleDocGridReady = (aParams) => {
    // console.log('handleDocGridReady ~ aParams', aParams);
    setDocGridRef(aParams);
  }

  const handleInfiniteDocGridReady = (aParams) => {
    setInfiniteDocGridRef(aParams);
  }




  const handleShowDeptListClick = () => {
    setShowDeptList(true);
  }

  const theme = useTheme();
  const [openDrawer, setOpenDrawer] = useState(true);



  const [openLogoutDialog, setOpenLogoutDialog] = useState(false);
  const [openMaintenanceDialog, setOpenMaintenanceDialog] = useState(false);
  const [openChangePwdDialog, setOpenChangePwdDialog] = useState(false);


  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [openUploadProgress, setOpenUploadProgress] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadFileCount, setUploadFileCount] = useState(0);
  // const [uploadCancel, setUploadCancel] = useState(false);
  // const [curUploadingFileProgress, setCurUploadingFileProgress] = useState(0);
  const [curUploadingFilename, setCurUploadingFilename] = useState("");
  const [curUploadingFileNo, setCurUploadingFileNo] = useState(0);


  const [initialFiles, setInitialFiles] = useState([]);

  const handleSelDept = (ADeptCode) => {
    setShowDeptList(false);
    const vDept = gState.depts.find(dept => dept.DeptCode === ADeptCode);
    doSetCurDept(vDept);
  }

  const refreshFolders = () => {
    const vFolderID = (selFolder?.id == undefined ? DmsCommon.VOID_FOLDER_ID : selFolder?.id);
    // console.log("refreshFolders", vFolderID);


    refreshFoldersByDeptCode(gState.curDeptCode, vFolderID);
  }




  const sequentialUploadFiles = async (AFiles) => {
    let totalSize = 0;
    for (const vFile of AFiles) {
      if (vFile.size > DmsCommon.MAX_FILE_SIZE) {
        throw new Error(`File size exceeds 2GB limit: ${vFile.name}`);
      }
      totalSize += vFile.size;
    }

    if (totalSize === 0) return;

    const vRstDocIDs = []

    let uploadedFileSize = 0;
    for (const [vFileIdx, vFile] of AFiles.entries()) {


      setCurUploadingFileNo(vFileIdx + 1);
      // setCurUploadingFileProgress(0);
      setCurUploadingFilename(vFile.name);

      const fileStartOffset = uploadedFileSize;
      const vFileID = await DmsService.uploadChunkedFilePromise(
        gState.sessionID,
        vFile,
        (progress, uploadedBytes) => {
          setUploadProgress(((fileStartOffset + uploadedBytes) * 100) / totalSize);
        }
      );

      uploadedFileSize += vFile.size;

      let vFindDoc = null;

      if (folderDocs && folderDocs.length > 0) {
        vFindDoc = folderDocs.find(d => d.Subject === vFile.name);
      }

      if (vFindDoc) {
        await DmsService.addDocRevPromise(gState.sessionID, selDept.DeptCode, vFindDoc.DocID, vFileID, vFile.name, vFile.size, "", []);
      } else {

        const docDateISO = dayjs().format(DmsCommon.ISO_DATE_FORMAT) || "";

        const vPermUserList = ['*'];

        const vNewDocID = await DmsService.docAddPromise(gState.sessionID, selDept.DeptCode, selFolder.id, vFile.name,
          docDateISO, '', gState.fullName, '', '', '', '', '', '', '', docDateISO,
          vFileID, vFile.name, vFile.size, [], [], vPermUserList);

        vRstDocIDs.push(vNewDocID);
      }


    }

    return vRstDocIDs


  }


  const handleConfirmUploadFiles = (AFiles, ADistList) => {
    // console.log("handleConfirmUploadFiles", AFiles);
    const oversizedFiles = (AFiles || []).filter(f => f.size > DmsCommon.MAX_FILE_SIZE).map(f => f.name);
    if (oversizedFiles.length > 0) {
      setErrMsg(`File size exceeds 2GB limit: ${oversizedFiles.join(', ')}`);
      setShowError(true);
      return;
    }

    const xFunc = async () => {
      setOpenUploadDialog(false);

      // setUploadCancel(false);
      setUploadProgress(0);
      setUploadFileCount(AFiles.length)
      setOpenUploadProgress(true);


      try {
        const vNewDocIDs = await sequentialUploadFiles(AFiles);

        setOpenUploadProgress(false);

        // Send Notification
        // console.log("vNewDocIDs", vNewDocIDs);
        if (ADistList.length > 0) {
          await DmsService.updateBatchDocDListPromise(
            gState.sessionID, selDept.DeptCode, vNewDocIDs, ADistList);
        }

      } catch (e) {
        handleNormalFuncError(e, 'hcuf');
      } finally {
        refreshFolders();
        setOpenUploadProgress(false);
      }
    }
    xFunc();


  }

  const [disableUpload, setDisabledUpload] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItem_MaintenanceClick = () => {
    handleMenuClose();
    setOpenMaintenanceDialog(true);
  }

  const handleMenuItem_ChangePwdClick = () => {
    handleMenuClose();
    setOpenChangePwdDialog(true);
  }

  const handleMenuItem_LogoutClick = () => {
    handleMenuClose();
    setOpenLogoutDialog(true);
  }


  const [adminFolders, setAdminFolders] = useState([]);

  const [showMaintain, setShowMaintain] = useState(false);

  // console.log("gState", gState);
  const vShowChangePwd = (selDept?.DeptCode == 'DMS_IC') && ((gState.domain == '') || (gState.domain == 'icpm.hld.com'));

  // const folderFooterRef = React.useRef();
  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      {showMaintain &&
        <MenuItem onClick={handleMenuItem_MaintenanceClick}>

          <ListItemIcon>
            <SettingsIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Maintenance</ListItemText>
        </MenuItem>
      }
      {vShowChangePwd &&
        <MenuItem onClick={handleMenuItem_ChangePwdClick}>

          <ListItemIcon>
            <LockIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Change Password</ListItemText>
        </MenuItem>
      }
      <MenuItem onClick={handleCompactModeToggle}>
        <ListItemIcon>
          <ViewCompactIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText primary="Compact Mode" />
        <Switch
          edge="end"
          checked={gState.useCompactMode}
          tabIndex={-1}
          disableRipple
        />
      </MenuItem>
      <MenuItem onClick={handleMenuItem_LogoutClick}>

        <ListItemIcon>
          <LogoutIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Logout</ListItemText>
      </MenuItem>
    </Menu>
  );


  const getDocDetail = async (aSessionID, aSysID, aDocID) => {
    // console.log("getDocDetail", aSessionID, aSysID, aDocID);

    try {
      const p1 = DmsService.getDocDetailPromise(aSessionID, aSysID, aDocID);
      const p2 = DmsService.getDocTypesPromise(aSessionID, aSysID);

      await Promise.all([p1, p2])
        .then((values) => {

          const [valDocDetail, valDocTypes] = values;
          // console.log("getDocDetailPromise success", docDetail);
          // console.log("getDocDetailPromise success selFolder", selFolder);

          setDocDetail(valDocDetail);
          setDocTypes(valDocTypes);

          setUpdatedDocForGrid(valDocDetail)
          // Refresh document list in case the document is moved to another folder
          if (valDocDetail.FolderID !== selFolder?.id) {
            refreshFolders();
          }



        })
    } catch (e) {
      handleNormalFuncError(e, 'gdd');
    }



  }

  const [openDocDetailDialog, setOpenDocDetailDialog] = useState(false);
  const [docDetail, setDocDetail] = useState(null);

  const handleOpenDocDetail = (aSysID, aDocID) => {
    // console.log("call handleOpenDocDetail", aSessionID);
    // console.log("call handleOpenDocDetail gState.sessionID", gState.sessionID);

    setShowLoading(true);

    getDocDetail(gState.sessionID, aSysID, aDocID)
      .then(() => {
        setShowLoading(false);

        setOpenDocDetailDialog(true);
      })
      .catch(e => {
        setShowLoading(false);

        handleNormalFuncError(e, 'hodd');
      })

  }



  const [updatingDetail, setUpdatingDetail] = useState(false);

  const handleUpdateDocDetail = (aSessionID, aSysID, aDocID) => {
    // console.log("call handleUpdateDocDetail", aSessionID, aSysID, aDocID);

    setUpdatingDetail(true);

    getDocDetail(aSessionID, aSysID, aDocID)
      .then(() => {
        setUpdatingDetail(false);
      })
      .catch(e => {
        console.log("getDocDetail fail", e);
        setUpdatingDetail(false);
      })

  }

  const [updatedDocForGrid, setUpdatedDocForGrid] = useState(null);

  const handleDocDetailClose = (aHasUpdate, aSessionID, aSysID, aDocID) => {
    setOpenDocDetailDialog(false);
    if (aHasUpdate === true) {
      // refreshDocs();

      // Send updated doc info to MainContent
      DmsService.getDocDetailPromise(aSessionID, aSysID, aDocID)
        .then((d) => {
          // console.log('handleDocDetailClose .getDocDetail d:', d);

          setUpdatedDocForGrid(d);
        })
        .catch(e => {
          console.log("getDocDetail fail", e);
          // setUpdatingDetail(false);
        })

    }
  }

  const handleMaintenanceClose = (aHasUpdate) => {
    // console.log("handleMaintenanceClose", aHasUpdate);
    setOpenMaintenanceDialog(false);

    if (aHasUpdate === true) {
      refreshFolders();

    }

  }

  const handleChangePwdClose = () => {
    // console.log("handleChangePwdClose");
    setOpenChangePwdDialog(false);

  }

  const [dragActive, setDragActive] = React.useState(false);

  // handle drag events
  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);


    // console.log('handleDrop')
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      // console.log('handleDrop has files', e.dataTransfer.files)

      const files = [];
      Array.from(e.dataTransfer.files).forEach((f) => {
        // console.log('f', f)
        files.push(f);
      });

      if (!selFolder) {
        setErrMsg("Please select a folder first!");
        setShowError(true);
      } else if (selFolder?.IsMonitorFolder && isMonitorOffline) {
        setErrMsg("The path is offline");
        setShowError(true);
      } else if (disableUpload == true) {
        setErrMsg("Unable to upload to this folder!");
        setShowError(true);
      } else {
        setInitialFiles(files);
        setOpenUploadDialog(true);
      }

    }

  };


  // const onDrop = (e) => {
  //   console.log('onDrop ~ onDrop:', e);
  //   // e.preventDefault();

  //   // const droppedData = JSON.parse(e.dataTransfer.getData("text/plain"));
  //   // setDroppedItems((prev) => [...prev, ...droppedData]);
  // };

  const [leftWidth, setLeftWidth] = useState(() => {
    const saved = localStorage.getItem("leftPanelWidth");
    return saved ? parseInt(saved, 10) : 300;
  });
  const [isDragging, setIsDragging] = useState(false);

  // prevent text selection when dragging
  document.body.style.userSelect = isDragging ? "none" : "auto";

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    // setLeftWidth(e.clientX);
    setLeftWidth(Math.max(200, e.clientX)); // adjust width based on mouse position
  };

  useEffect(() => {
    localStorage.setItem("leftPanelWidth", leftWidth);
  }, [leftWidth]);

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  return (
    <Box
      sx={{
        display: "flex",
        height: "100%",
        overflow: "hidden",
      }}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
    >
      <CssBaseline />

      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <MsgDialog
        open={showError}
        title="Error"
        msgText={errMsg}
        onClose={() => setShowError(false)}
      />


      <ConfirmSendNotificaitonDialog
        open={openMoveDocDialog}
        onCancelClick={() => setOpenMoveDocDialog(false)}
        onMoveClick={() => {
          setOpenMoveDocDialog(false);
          moveDocs();
        }}
        onMoveAndSendClick={() => {
          setOpenMoveDocDialog(false);
          setOpenSendNotificationMoveDocDialog(true);
        }}
      />

      {openImageViewerDialog && (
        <Lightbox
          mainSrc={fileSrc}
          clickOutsideToClose
          onCloseRequest={() => setOpenImageViewerDialog(false)}
        />
      )}

      <FileViewerDialog />

      <SendNotificationForMoveDocDialog
        sysID={selSysID}
        targetFolderID={moveTargetFolderID}
        open={openSendNotificationMoveDocDialog}
        docIDs={moveDocIDs}
        onSend={(aDList) => {
          // console.log("onSend aDList", aDList);
          setOpenSendNotificationMoveDocDialog(false);
          moveDocs(aDList);
        }}
        onClose={() => {
          setOpenSendNotificationMoveDocDialog(false);
          moveDocs();
        }}
      />

      <DocDetailDialog
        open={openDocDetailDialog}
        sysID={selSysID}
        docDetail={docDetail}
        afterDocDetailUpdate={handleUpdateDocDetail}
        updatingDetail={updatingDetail}
        folders={folders}
        docTypes={docTypes}
        onClose={handleDocDetailClose}
      />
      <DeptListDialog
        open={showDeptList}
        depts={gState.depts}
        selDeptCode={selSysID}
        onClose={() => setShowDeptList(false)}
        onSelDept={handleSelDept}
      />
      <FolderInfoDialog
        sysID={selSysID}
        open={openFolderInfoDialog}
        onClose={() => setOpenFolderInfoDialog(false)}
        folder={selFolder}
      />

      <UploadFilesDialog
        sysID={selSysID}
        folderID={selFolder?.id || 0}
        open={openUploadDialog}
        iniFiles={initialFiles}
        onClose={() => setOpenUploadDialog(false)}
        onUpload={handleConfirmUploadFiles}
      />
      <UploadFilesProgress
        open={openUploadProgress}
        overAllProgress={uploadProgress}
        fileCount={uploadFileCount}
        curFileNo={curUploadingFileNo}
        curFilename={curUploadingFilename}
      // onCancel={handleCancelUpload}
      />


      {/* LEFT PANEL */}
      <Paper
        variant="outlined"
        square
        sx={{
          width: leftWidth,
          height: "100%",
          flexShrink: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box sx={{ p: 0, bgcolor: 'yellowgreen', flexShrink: 0 }} >

          <AppBar
            position="static"
          >
            <Toolbar variant="dense" sx={{ px: { xs: 1 } }}  >
              {gState.depts?.length > 1 &&
                <IconButton
                  color="inherit"
                  aria-label="dmsList"
                  edge="start"
                  onClick={(e) => handleShowDeptListClick()}
                >

                  <ListAltIcon />
                </IconButton>
              }

              <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
                {selDept?.DeptName || "DMS"}
              </Typography>
              {/* <IconButton color="inherit" edge="end" onClick={() => setOpenDrawer(false)}>
                {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
              </IconButton> */}
            </Toolbar>
          </AppBar>


        </Box>
        <Box
          component="div"
          sx={{
            display: 'flex', p: 0,
            height: '100%',
            flex: '1 1 0px', minHeight: 0,
            overflow: 'hidden'
            // display: 'flex', p: 0, height: 1, overflowY: 'scroll'
          }}>
          <FolderTreeList2
            // ref={folderFooterRef}
            sx={{ mb: 6 }}
            // drawerWidth={drawerWidth}
            folders={folders}
            selFolderID={selFolder?.id}
            compactMode={gState.useCompactMode}
            onChangeFolderID={handleChangeFolderID}
            disableAllFolder
            disablePersonalFolder
            disableVirtualTree
            onItemListChanged={handleFolderListChanged}
            onFolderInfoClick={handleFolderInfoClick}
          />

        </Box>
        <Box
          sx={{
            minHeight: gState.useCompactMode ? 32 : 48, height: gState.useCompactMode ? 32 : 48,
            flexShrink: 0,
            borderTop: "1px solid",
            borderColor: "divider",
            display: "flex",
            alignItems: "center",
            px: 2,
          }}
        >
          <Typography variant="subtitle1" noWrap component="div" align="left" sx={{ flexGrow: 1 }} />
        </Box>
      </Paper>

      {/* DIVIDER */}
      <Box
        onMouseDown={() => setIsDragging(true)}
        sx={{
          width: "5px",
          cursor: "col-resize",
          backgroundColor: "#ddd",
          "&:hover": {
            backgroundColor: "#aaa"
          }
        }}
      />

      {/* RIGHT PANEL */}
      <Paper
        variant="outlined"
        square
        sx={{
          flex: 1,
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <Box sx={{ p: 0, bgcolor: 'grey.300', }} >
          <AppBar
            position="static"
          >
            <Toolbar variant="dense" sx={{ px: { xs: 1 } }}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={() => setOpenDrawer(true)}
                edge="start"
                sx={{ mr: 2, ...(openDrawer && { display: 'none' }) }}
              >
                <ChevronRightIcon />
              </IconButton>
              <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }} >
                {selFolder?.FolderName || ""}
                {selFolder?.IsMonitorFolder && (
                  <Tooltip title={isMonitorOffline ? "Monitor folder is offline/inaccessible" : "Monitor folder is online"}>
                    <IconButton
                      size="small"
                      sx={{ ml: 1, color: isMonitorOffline ? 'error.main' : '#ffd600' }}
                    >
                      {isMonitorOffline ? <CloudOffIcon /> : <CloudQueueIcon />}
                    </IconButton>
                  </Tooltip>
                )}
              </Typography>
              <Typography variant="subtitle1" noWrap component="div" sx={{ display: { xs: "none", lg: "block" } }}  >
                {gState.fullName || ""}
              </Typography>
              <IconButton
                // size="large"
                // edge="end"
                aria-label="account of current user"
                aria-controls={menuId}
                aria-haspopup="true"
                onClick={handleProfileMenuOpen}
                color="inherit"
              >
                <MoreHorizIcon />
              </IconButton>

              <MaintenanceDialog
                open={openMaintenanceDialog}
                sysID={selSysID}
                folders={folders}
                adminFolders={adminFolders}
                onClose={handleMaintenanceClose}
              />
              <ChangePwdDialog
                open={openChangePwdDialog}
                sysID={selSysID}
                onClose={handleChangePwdClose}
              />
              <LogoutDialog
                open={openLogoutDialog}
                onCancelClick={() => setOpenLogoutDialog(false)}
                onLogoutClick={handleConfirmLogout}
              />



              <SignInDialog
                open={openSignInDialog}
                onClose={() => setOpenSignInDialog(false)}
              />

            </Toolbar>
          </AppBar>

          {renderMenu}

        </Box>

        <Box component="div" sx={{ display: 'flex', p: 0, height: 1, maxHeight: 1, overflow: 'auto' }}

        >
          <Box sx={{ display: 'flex', width: 1, flexDirection: 'column', flexGrow: 1, p: 0 }}
            component="form"
            onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}
          >
            <Box sx={{ display: 'flex', width: 1, flexDirection: 'column', flexGrow: 1, p: 0 }}
              component="form"
              onDragEnter={handleDrag} onSubmit={(e) => e.preventDefault()}
            >
              <input type="file" id="input-file-upload" multiple={false} />

              <Box sx={{ display: dragActive ? 'none' : 'flex', width: 1, flexDirection: 'row', flexGrow: 1, p: 0 }} >
                <MainContent

                  isExternal={isFromExternal}
                  sysID={selSysID}
                  // dept={selDept}

                  folder={selFolder}
                  folders={searchFolders}

                  updatedDoc={updatedDocForGrid}

                  // totalDocCnt={docs.length}

                  searchDocs={searchDocs}
                  onDrawerToggle={handleDrawerToggle}

                  iniSelDocID={passInDocID}
                  compactMode={gState.useCompactMode}

                  onViewDoc={handleViewDoc}
                  onDownloadDoc={handleDownloadDoc}
                  onDeleteDoc={handleDeleteDoc}
                  onPrintIndex={handlePrintIndex}
                  onSearch={handleSearchDoc}
                  onDocDetail={handleOpenDocDetail}
                  afterDocDetailUpdate={handleUpdateDocDetail}
                  onRefresh={refreshFolders}
                  disableUpload={disableUpload}
                  onDocGridReady={handleDocGridReady}
                  onInfiniteDocGridReady={handleInfiniteDocGridReady}
                  onFetchedDoc={onFetchedDoc}
                  onError={handleNormalFuncError}
                  isMonitorOffline={isMonitorOffline}
                />

              </Box>
              {dragActive &&
                <div id="drag-file-element" onDragEnter={handleDrag} onDragLeave={handleDrag}
                  onDragOver={handleDrag} onDrop={handleDrop}>
                  <p>Drag file here</p>
                </div>}
            </Box>
          </Box>
          {/* <PDFViewer pdfUrl={pdfUrl} /> */}

          {/* <img ref={imgRef} src={"images/測試一二三.jpg"} style={{ maxWidth: "100%" }} onClick={() => showMarkerArea()} /> */}
        </Box>
        <Box
          sx={{
            minHeight: gState.useCompactMode ? 32 : 48, height: gState.useCompactMode ? 32 : 48,
            flexShrink: 0,
            borderTop: "1px solid",
            borderColor: "divider",
            display: "flex",
            alignItems: "center",
            px: 2,
          }}
        >
          <Typography variant="subtitle1" noWrap component="div" align="center" sx={{ flexGrow: 1 }} >
            {folderDocTot} document(s)
          </Typography>
          <Typography variant="subtitle2" noWrap component="div" align="right" >
            {(process.env.REACT_APP_ENV != "Prod") ? process.env.REACT_APP_ENV : ""}
          </Typography>
        </Box>

      </Paper>
    </Box>
  );
}


export default App;
